<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->
<gm-showcase showcase-title="GM Directory Search">
<div class="showcase-body">
  <div style="margin: auto; max-width: 1200px; margin-bottom: 50px;margin-top: 20px;">
    <GMINSearch></GMINSearch>
  </div>
</div>
</gm-showcase>
